define('webshopProductsListToolsView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'settings',
  'tableFieldView',
  'buttonView',
  'template!webshopProductsListToolsView'
], function (
  App,
  Module,
  Backbone,
  _,
  Settings,
  FieldView,
  ButtonView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'webshop-products-list-tools-view ' + FieldView.prototype.className,

    ui: {
      redirected: '.redirected'
    },

    regions: {
      cleanCacheButtonRegion: '.clean-cache-button-region'
    },

    events: {
      'click @ui.deleteCache': 'onDeleteCache'
    },

    onRender: function () {
      this.cleanCacheButtonView = new ButtonView({
        type: 'clean-cache',
        color: 'lightgrey',
        title: _.i18n('common.delete-cache')
      });
      this.getRegion('cleanCacheButtonRegion').show(this.cleanCacheButtonView);
      this.cleanCacheButtonView.on('click', _.bind(this.onCleanCache, this));

      //-----------------------------
      if(this.model.get('redirected'))
        this.ui.redirected.css('display', 'flex');
      else
        this.ui.redirected.hide();
    },

    onCleanCache: function () {
      this.cleanCacheButtonView.loading(true);
      this.model.clearCache().always(_.bind(function () {
        this.cleanCacheButtonView.loading(false);
      }, this));
    }
  });
});
